import styled from 'styled-components';
import { themeGet } from 'modules/v2/foundation/theme';
export const DefinitionList = styled.dl `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.lg')};
`;
export const Definition = styled.dd `
  grid-column: 2;
  width: fit-content;
`;
